import MISC from '@/js/miscellaneous.js'

function toJsonV1(template) {
  const codeLanguages = {'한국어': 'ko', '영어': 'en', '숫자': 'nu', '특수기호': 'sy'}
  const codeDictionary = {'없음':null, '주소': 'addr', '주문모델': 'goods', '거래처': 'shop'}
  let jsonObj = {
    version: '1.0.0',
    id: template.templateId,
    sampleId: template.sampleId,
    sampleSize: template.sampleSize,
    sampleFileExtension: template.sampleFileExtension,
    name: template.templateName,
    creationDate: template.creationDate == undefined ? new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().split('.')[0].replace('T', ' ') : template.creationDate,
    lastModifiedDate: template.lastModifiedDate == undefined ? new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().split('.')[0].replace('T', ' ') : template.lastModifiedDate,
    creationBy: template.creationBy,
    layouts: []
  }
  for (let field of template.fields) {
    let exclusion = Object.keys(codeLanguages).filter(v => field.language.indexOf(v) == -1).map(v => codeLanguages[v]).join('|')
    if (exclusion.length == 0)
      exclusion = null
    jsonObj.layouts.push({
      name: field.name,
      exclusion,
      dict: codeDictionary[field.dictionary.name],
      rect: `${parseInt(field.rect[0])},${parseInt(field.rect[1])},${parseInt(field.rect[2])},${parseInt(field.rect[3])}`,
      must_pick: field.dictionary.mustPick,
      writingType: field.writingType
    })
  }

  return jsonObj
}

function fromJsonV1(jsonV1, fieldColors) {
  const codeLanguages = {'ko': '한국어', 'en': '영어', 'nu': '숫자', 'sy': '특수기호'}
  const codeDictionary = {null: '없음', 'addr': '주소', 'goods': '주문모델', 'shop': '거래처'}
  let template = {
    templateId: jsonV1.id,
    sampleId: jsonV1.sampleId,
    sampleSize: jsonV1.sampleSize,
    sampleFileExtension: jsonV1.sampleFileExtension,
    templateName: jsonV1.name,
    creationDate: jsonV1.creationDate,
    lastModifiedDate: jsonV1.lastModifiedDate,
    creationBy: jsonV1.creationBy,
    fields: []
  }
  
  if (fieldColors == undefined)
    fieldColors = ['#FF0000']
  for (let idx in jsonV1.layouts) {
    const layout = jsonV1.layouts[idx]
    const coords = layout.rect.split(',')
    const rect = [parseInt(coords[0]), parseInt(coords[1]), parseInt(coords[2]), parseInt(coords[3])]
    
    let langs = []
    if (layout.exclusion != null) {
      langs = layout.exclusion.split('|')
    }
    let language = Object.keys(codeLanguages).filter(v => langs.indexOf(v)).map(v => codeLanguages[v])
    template.fields.push({
      id: MISC.getUuid4(),
      type: '기본',
      color: fieldColors[idx % fieldColors.length],
      name: layout.name,
      language,
      dictionary: {name: codeDictionary[layout.dict], mustPick: layout.must_pick},
      rect,
      mustPick: layout.must_pick,
      writingType: layout.writingType
    })
  }

  return template
}

function trimField(field) {
  return {
    type: field.type,
    name: field.name,
    language: field.language,
    dictionary: field.dictionary,
    rect: field.rect,
    writingType: field.writingType
  }
}

function fieldToLayout (field) {
  const codeLanguages = {'한국어': 'ko', '영어': 'en', '숫자': 'nu', '특수기호': 'sy'}
  const codeDictionary = {'없음':null, '주소': 'addr', '주문모델': 'goods', '거래처': 'shop'}
  let exclusion = Object.keys(codeLanguages).filter(v => field.language.indexOf(v) == -1).map(v => codeLanguages[v]).join('|')
  if (exclusion.length == 0)
    exclusion = null
  return {
    name: field.name,
    exclusion: exclusion,
    dict: codeDictionary[field.dictionary.name],
    rect: `${field.rect[0]},${field.rect[1]},${field.rect[2]},${field.rect[3]}`,
    must_pick: field.dictionary.mustPick,
    style: field.writingType == '인쇄체' ? 'print' : 'hwr'
  }
}

export default {
  toJsonV1,
  fromJsonV1,
  trimField,
  fieldToLayout
}
